export default __webpack_public_path__ + "static/media/invite_friend_bg.1ebdf349.png";